import React from "react";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { create } from "jss";
import rtl from "jss-rtl";
import { SnackbarProvider } from "notistack";
import {
  createStyles,
  jssPreset,
  makeStyles,
  StylesProvider,
  ThemeProvider,
} from "@material-ui/core";
import Auth from "src/components/Auth";
import ScrollReset from "src/components/ScrollReset";
import useSettings from "src/hooks/useSettings";
import { createTheme } from "src/theme";
import Routes from "src/Routes";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import CookiesNotification from "src/components/CookiesNotification";
import SettingsNotification from "src/components/SettingsNotification";
import Axios from "axios";
import { RequestDataHolder } from "./context/RequestDataHolder";

Axios.defaults.baseURL = process.env.REACT_APP_API;
Axios.defaults.headers.common["X-Frame-Options"] = "SAMEORIGIN";

const history = createBrowserHistory();
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const useStyles = makeStyles(() =>
  createStyles({
    "@global": {
      "*": {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
      },
      html: {
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        height: "100%",
        width: "100%",
      },
      body: {
        height: "100%",
        width: "100%",
      },
      "#root": {
        height: "100%",
        width: "100%",
      },
    },
  })
);

function App() {
  useStyles();
  const { settings } = useSettings();
  return (
    <ThemeProvider theme={createTheme(settings)}>
      <StylesProvider jss={jss}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <SnackbarProvider maxSnack={1}>
            <Router history={history}>
              <Auth>
                <ScrollReset />
                {/* <GoogleAnalytics /> */}
                <CookiesNotification />
                <SettingsNotification />
                <RequestDataHolder>
                  <Routes />
                </RequestDataHolder>
              </Auth>
            </Router>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  );
}

export default App;
